module.exports = __webpack_public_path__ + "img/sidebar.8c9a1c2c.png";